import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TextField, CircularProgress, Container, Autocomplete, Tabs, Stack, Grid, Button } from "@mui/material";
import { debounce } from "@mui/material/utils";
import { useSearchBomsQuery } from "../rtk/search";
import ImageViewer from "../ImageViewer";
import DragDropFile from "../components/DragDropFile";
import api from "../api";

const BomPart3DManager = (props) => {
    const { t } = useTranslation();

    const [selectedBom, setSelectedBom] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [debouncedInputValue, setDebouncedInputValue] = useState('');
    const [files, setFiles] = useState([]);

    // Create a memoized debounced function
    const debouncedSetInput = useMemo(
        () => debounce((value) => {
            setDebouncedInputValue(value);
        }, 300),
        []
    );

    const { data: boms = [], isLoading } = useSearchBomsQuery(debouncedInputValue, {
        skip: debouncedInputValue.length < 2,
    });

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        debouncedSetInput(newInputValue);
    };

    const handleValidateParts = async () => {
        if (!selectedBom) return;
        
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("files", file);
        });
        formData.append("bom", selectedBom.id);

        try {
            let res = await api.post("/boms/validate-parts/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("Validation result:", res.data);
            // Handle the response data as needed
        } catch (error) {
            console.error("Error validating parts:", error);
        }
    };

    return (
        <Container maxWidth="xl" style={{ marginTop: '20px' }}>
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                <Grid item xs={4} md={2}>
                    <Stack direction="column" spacing={1}>
                        <Autocomplete
                            options={boms}
                            getOptionLabel={(option) => option.name}
                            loading={isLoading}
                            value={selectedBom || null}
                            inputValue={inputValue}
                            filterOptions={(x) => x}
                            onInputChange={handleInputChange}
                            onChange={(event, newValue) => {
                                setSelectedBom(newValue ? newValue : null);
                            }}
                            clearOnBlur={false}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("Select BOM")}
                                    variant="outlined"
                                    fullWidth
                                    value={inputValue}
                                    placeholder={t("Type to search...")}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                        <DragDropFile
                            label={t("3D Part Files")}
                            accept={".stl"}
                            disabled={!selectedBom}
                            multiple={true}
                            files={files}
                            onFiles={setFiles}
                            height={150}
                            description={t("Drag and drop 3D part files here, or click to select files.")}
                        />
                        <Button variant="contained" color="primary" onClick={handleValidateParts} disabled={!selectedBom || files.length === 0}>
                            {t("Validate Parts")}
                        </Button>   
                    </Stack>
                </Grid>
            </Grid >

            {/* find a way to display this  */}
            {/* <ImageViewer
                filename={selectedBom ? selectedBom.name.slice(0, -1) : null}
                minHeight={"80vh"}
                minWidth={"70vw"}
                bom={selectedBom ? selectedBom.name : null}
            /> */}
        </Container >
    );
};

export default BomPart3DManager;